<template>
    <div class="form-group">
        <div class="dropzone" id="recipeGallery"></div>
        <div class="dz-message"></div>
        <p class="help-block">Tänk på att inte ladda upp copyrightskyddat material.</p>
        <div class="dropzone-previews" id="dropzonePreview"></div>
        <input type="hidden" v-for="fileName in gallery" :name="'recipe_gallery[]'" :value="fileName" />
    </div>
</template>

<script>
import Dropzone from 'dropzone';

export default {
    props: {
        initialGallery: Array
    },

    data() {
        return {
            gallery: [],
            fileName: ''
        };
    },

    mounted() {
        const initialGallery = this.initialGallery ? this.initialGallery : [];
        const gallery = this.gallery;
        let fileName = this.fileName;

        Dropzone.options.recipeGallery = {
            url: '/recept/upload',
            paramName: 'upload',
            uploadMultiple: false,
            parallelUploads: 5,
            maxFiles: 5,
            maxFilesize: 20,
            addRemoveLinks: false,
            dictDefaultMessage: 'Klicka här eller dra dina bilder hit',
            dictFileTooBig: 'Bilden du laddat upp är för stor',
            autoDiscover: false,
            dictCancelUpload: 'Avbryt',
            dictCancelUploadConfirmation: 'Är du säker på att du vill avbryta uppladdningen?',
            headers: {
                'X-CSRF-TOKEN': $('meta[name="csrf_token"]').attr('content')
            },

            init: function () {
                initialGallery.forEach((image) => {
                    let mockFile = { name: image, size: 5555, accepted: true };
                    this.emit('addedfile', mockFile);
                    this.emit('thumbnail', mockFile, '/assets/media/small/recipe/' + image);
                    this.emit('complete', mockFile);

                    Dropzone.options.recipeGallery.initRemoveFile(mockFile, this);

                    gallery.push(image);
                });
            },

            success: function (file, xhr) {
                fileName = xhr.fileName;
                gallery.push(fileName);

                Dropzone.options.recipeGallery.initRemoveFile(file, this);
            },

            initRemoveFile: function (file, dropzoneInstance) {
                // Create the remove button
                let removeButton = Dropzone.createElement("<button class='dz-remove'>Ta bort</button>");

                // Capture the Dropzone instance as closure.
                let _this = dropzoneInstance;

                // Listen to the click event
                removeButton.addEventListener('click', function (e) {
                    // Make sure the button click doesn't submit the form:
                    e.preventDefault();
                    e.stopPropagation();

                    // Remove the file preview.
                    _this.removeFile(file);
                });

                // Add the button to the file preview element.
                file.previewElement.appendChild(removeButton);
            },

            removedfile: function (file) {
                let index = gallery.indexOf(file.name);
                gallery.splice(index, 1);

                file.previewElement.remove();
                file.previewTemplate.remove();
            }
        };
    }
};
</script>
